import { IconColumns } from '@tabler/icons-react';
import {
    UncontrolledDropdown, DropdownToggle, DropdownItem, DropdownMenu,
} from 'reactstrap';
import { NSButton, NSCheckbox } from 'bricks';
import { IOptionStringValue } from 'bricks/types';

export type IVisibleColumns = Record<string, boolean>

export interface IColumnsDropdownProps {
    visibleColumns: IVisibleColumns;
    updateVisibleColumns: (visibleColumns: IVisibleColumns) => void;
    columnOptions: IOptionStringValue[];
}

const ColumnsDropdown = ({
    visibleColumns, updateVisibleColumns, columnOptions,
}: IColumnsDropdownProps) => {
    const isCheckedAll = Object.values(visibleColumns).filter(checked => checked).length === columnOptions.length;

    const toggleAll = (isChecked: boolean) => {
        const updatedVisibleColumns: IVisibleColumns = {};

        columnOptions.forEach(({ value }) => {
            updatedVisibleColumns[value] = isChecked;
        });

        updateVisibleColumns(updatedVisibleColumns);
    };

    const toggleVisibleColumn = (key: string) => {
        const updatedVisibleColumns = {
            ...visibleColumns,
            [key]: !visibleColumns[key],
        };

        updateVisibleColumns(updatedVisibleColumns);
    };

    return (
        <UncontrolledDropdown>
            <DropdownToggle tag="div">
                <NSButton className="mr-2" icon={IconColumns} outline={false} color="secondary" />
            </DropdownToggle>
            <DropdownMenu className="text-white overflow-auto">
                <DropdownItem header className="text-uppercase text-primary m-0 px-2 py-1">
                    <small>Columns:</small>
                </DropdownItem>
                <DropdownItem className="px-2 py-1" toggle={false}>
                    <NSCheckbox
                        id="select-all"
                        labelText="All"
                        callback={toggleAll}
                        size="sm"
                        checked={isCheckedAll}
                        iconClassName="mr-2 cursor--pointer"
                        labelClassName="font-weight-normal text-white"
                    />
                </DropdownItem>

                {columnOptions.map(option => (
                    <DropdownItem className="px-2 py-1" toggle={false} key={option.value}>
                        <NSCheckbox
                            id={option.value}
                            labelText={option.label}
                            callback={() => toggleVisibleColumn(option.value)}
                            size="sm"
                            checked={!!visibleColumns[option.value]}
                            iconClassName="mr-2 cursor--pointer"
                            labelClassName="font-weight-normal text-white"
                        />
                    </DropdownItem>
                ))}
            </DropdownMenu>
        </UncontrolledDropdown>
    );
};

export default ColumnsDropdown;
